module.exports = __webpack_public_path__ + "static/img/bg_top2.283e75f5.png";